import { PlusOutlined } from "@ant-design/icons";
import { Card, Modal, Space, Spin, Upload, message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { IoDocumentTextOutline } from "react-icons/io5";

import "./detail.less";

const Facts = ({ facts = {}, getDetailData }) => {
  const [fileList, setFileList] = useState([]);
  // Зураг хуулах/устгах хүсэлт явж байх үед
  const [fileSaving, setFileSaving] = useState(false);

  useEffect(() => {
    const uploadedFiles = facts.images?.map((image) => ({ url: image })) ?? [];
    if (facts.signature) uploadedFiles.push({ url: facts.signature });
    setFileList(uploadedFiles);
  }, [facts]);

  /**
   * Зургийг шууд устгахгүй — хэрэглэгчээс баталгаажуулна. Promise `false`-аар
   * шийдэгдвэл Upload зургийг жагсаалтаас хасахгүй, onChange ч дуудагдахгүй.
   */
  const confirmRemove = () =>
    new Promise((resolve) => {
      Modal.confirm({
        title: "Зургийг устгах уу?",
        okText: "Устгах",
        cancelText: "Болих",
        okButtonProps: { danger: true },
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

  const uploadProps = {
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    onRemove: () => confirmRemove(),
    fileList,
  };

  const handleUpload = async ({ file }) => {
    const formData = new FormData();
    fileList.forEach((item) => {
      formData.append("files[]", item);
    });
    try {
      const { data } = await axios.post(
        `${
          process.env.REACT_APP_STORAGE_URL
        }/upload/operator/merchant?fileName=image${Date.now()}&uid=${file.uid}`,
        formData
      );
      if (data.statusCode === 200) {
        const body = {
          code: facts?.code,
          image: data?.result?.location,
        };
        await axios.post("/api/v1.0/request/uploadFile", body);
        getDetailData(facts?._id);
        setFileList([]);
        message.success("Амжилттай хуулагдлаа.");
      }
    } catch (error) {
      // Алдааны мэдэгдлийг axios interceptor аль хэдийн гаргасан — давхардуулахгүй
      console.error("uploadFile: ", error);
    }
  };

  const removeFile = async ({ file }) => {
    const body = {
      code: facts?.code,
      image: file.url,
    };
    const { data } = await axios.post("/api/v1.0/request/removeFile", body);
    if (data.statusCode === 200) {
      getDetailData(facts?._id);
    }
  };

  const onChangeFile = async ({ file }) => {
    setFileSaving(true);
    try {
      if (file?.status === "removed") {
        await removeFile({ file });
      } else {
        await handleUpload({ file });
      }
    } finally {
      setFileSaving(false);
    }
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div className="upload_btn_text">Зураг оруулах</div>
    </div>
  );

  return (
    <Space direction="vertical" size={16} style={{ width: "100%", padding: 16 }}>
      <Card
        title={
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <IoDocumentTextOutline style={{ display: "block", fontSize: "1em" }} />
            Баримт оруулах
          </span>
        }
        size="middle"
      >
        <Spin spinning={fileSaving}>
          <div style={{ paddingInline: "1px", paddingBottom: "16px" }}>
            <Upload
              {...uploadProps}
              listType="picture-card"
              fileList={fileList}
              onChange={onChangeFile}
              disabled={fileSaving}
            >
              {uploadButton}
            </Upload>
          </div>
        </Spin>
      </Card>
    </Space>
  );
};

export default Facts;
